import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Caret from "../../public/site-assets/svg/caret.svg";
import AnchorLink from "react-anchor-link-smooth-scroll";

export const ImageWithVideoBanner = ({
  customClass = "",
  content,
  buttonTitle,
  buttonLink,
  image,
  videoLink,
  videoGalleryClass = "WhatWeDo",
  sectionId = "",
  pageAnchor,
}) => {
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {});
    return () => Fancybox.destroy();
  }, []);

  return (
    <section className={`${styles.root} ${customClass}`} id={`${sectionId}`}>
      <Container>
        <div className="position-relative p-md-5 p-4 rounded-3 overflow-hidden">
          <div className="imageWrapper position-absolute">
            <img
              src={
                image?.url
                  ? image.url
                  : "/site-assets/placeholders/img-placeholder.jpg"
              }
              alt={image?.alt}
              className="card-img rounded-0"
            />
          </div>
          <div className="position-relative">
            <div className="contentWrapper">
              {content ? (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              ) : null}
              {videoLink ? (
                <a
                  className="fancyBox d-inline-block position-absolute"
                  data-fancybox={`${videoGalleryClass}`}
                  href={videoLink}
                  aria-label="Play"
                >
                  <span className="play">
                    <Caret />
                  </span>
                </a>
              ) : null}
            </div>
            {buttonLink ? (
              <div>
                {pageAnchor ? (
                  <AnchorLink
                    offset="80"
                    href={`#${pageAnchor}`}
                    className="primaryBtn no-arrow m-0"
                  >
                    {buttonTitle}
                  </AnchorLink>
                ) : (
                  <Link href={`${buttonLink}`}>
                    <a className="primaryBtn no-arrow m-0">{buttonTitle}</a>
                  </Link>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ImageWithVideoBanner;
